<template>
  <button
    id="dropdown-menu-button"
    class="min-w-32 text-gray-300 bg-neutral-700 shadow shadow-blue-500 focus:outline-none focus:ring-0 rounded-xl text-sm px-4 py-2 text-center inline-flex items-center justify-between gap-3 capitalize"
    type="button"
  >
    <div class="flex items-center gap-1">
      <img
        v-if="
          this.$store.state.network.chain &&
          !['home', 'dashboard'].includes(this.currentRouteName)
        "
        :src="this.$store.state.network.chain.logo"
        alt=""
        class="w-[20px]"
      />
      <span class="font-semibold text-blue-400 uppercase tracking-widest">
        {{ this.currentRouteName }}
      </span>
    </div>
    <svg
      class="w-2.5 h-2.5 ms-3"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 10 6"
    >
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="m1 1 4 4 4-4"
      />
    </svg>
  </button>
  <div
    id="dropdown-menu"
    class="z-10 hidden divide-y rounded-xl shadow w-36 bg-neutral-700 divide-gray-600 overflow-hidden"
  >
    <ul class="py-1 text-sm text-gray-300">
      <li
        v-if="this.currentRouteName !== 'solana'"
        @click="this.dropdown.hide()"
      >
        <router-link
          class="px-2 py-1.5 hover:bg-gray-600 hover:text-blue-500 flex items-center gap-1"
          to="/solana"
        >
          <img src="./../assets/solana.webp" alt="" class="w-[20px]" />
          Solana
        </router-link>
      </li>
      <li
        v-if="this.currentRouteName !== 'ethereum'"
        @click="this.dropdown.hide()"
      >
        <router-link
          class="px-2 py-1.5 hover:bg-gray-600 hover:text-blue-500 flex items-center gap-1"
          to="/ethereum"
        >
          <img src="./../assets/ethereum.webp" alt="" class="w-[20px]" />
          Ethereum
        </router-link>
      </li>
      <li v-if="this.currentRouteName !== 'bsc'" @click="this.dropdown.hide()">
        <router-link
          class="px-2 py-1.5 hover:bg-gray-600 hover:text-blue-500 flex items-center gap-1"
          to="/bsc"
        >
          <img src="./../assets/bsc.svg" alt="" class="w-[20px]" />
          BSC
        </router-link>
      </li>
      <li v-if="this.currentRouteName !== 'base'" @click="this.dropdown.hide()">
        <router-link
          class="px-2 py-1.5 hover:bg-gray-600 hover:text-blue-500 flex items-center gap-1"
          to="/base"
        >
          <img src="./../assets/base.webp" alt="" class="w-[20px]" />
          Base
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { Dropdown } from "flowbite";

export default {
  name: "DropdownMenu",
  data() {
    return {
      dropdown: null,
    };
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {},
  mounted() {
    this.dropdown = new Dropdown(
      document.getElementById("dropdown-menu"),
      document.getElementById("dropdown-menu-button"),
      {
        placement: "bottom",
        triggerType: "click",
        offsetSkidding: 0,
        offsetDistance: 10,
        delay: 300,
        ignoreClickOutsideClass: false,
      }
    );
  },
};
</script>
